import { apiPlugin, ISbStoriesParams, storyblokInit } from '@storyblok/react/rsc';

import { env } from '@natu/env';

import { SBArticle } from '../blog/src/components/contentTypes/SBArticle/SBArticle';
import { SBArticleAuthor } from '../blog/src/components/contentTypes/SBArticleAuthor/SBArticleAuthor';
import { SBArticleCategory } from '../blog/src/components/contentTypes/SBArticleCategory/SBArticleCategory';
import { SBArticleCard } from '../blog/src/components/elements/SBArticleCard/SBArticleCard';
import { SBArticlesByFilters } from '../blog/src/components/elements/SBArticlesByFilters/SBArticlesByFilters';
import { SBArticleShowcase } from '../blog/src/components/elements/SBArticleShowcase/SBArticleShowcase';
import { SBCategoriesBar } from '../blog/src/components/elements/SBCategoriesBar/SBCategoriesBar';
import { SBCareerOffer } from '../components/contentTypes/SBCareerOffer';
import { SBFooter } from '../components/contentTypes/SBFooter';
import { SBHeader } from '../components/contentTypes/SBHeader';
import { SBPage } from '../components/contentTypes/SBPage';
import { SBPreHeader } from '../components/contentTypes/SBPreHeader/SBPreHeader';
import { SBAvatarGroup } from '../components/elements/atoms/SBAvatarGroup/SBAvatarGroup';
import { SBCounter } from '../components/elements/atoms/SBCounter/SBCounter';
import { SBCta } from '../components/elements/atoms/SBCta/SBCta';
import { SBEWebinarButton } from '../components/elements/atoms/SBEWebinarButton/SBEWebinarButton';
import { SBImage } from '../components/elements/atoms/SBImage/SBImage';
import { SBLogo } from '../components/elements/atoms/SBLogo/SBLogo';
import { SBQuaterCircleWithText } from '../components/elements/atoms/SBQuaterCircleWithText/SBQuaterCircleWithText';
import { SBRichtext } from '../components/elements/atoms/SBRichtext/SBRichtext';
import { SBSeparator } from '../components/elements/atoms/SBSeparator/SBSeparator';
import { SBTypography } from '../components/elements/atoms/SBTypography/SBTypography';
import { SBVideo } from '../components/elements/atoms/SBVideo/SBVideo';
import { SBAboutServiceCard } from '../components/elements/cards/SBAboutServiceCard/SBAboutServiceCard';
import { SBBackgroundCard } from '../components/elements/cards/SBBackgroundCard';
import { SBCardTestimonial } from '../components/elements/cards/SBCardTestimonial';
import { SBCaseStudyCard } from '../components/elements/cards/SBCaseStudyCard/SBCaseStudyCard';
import { SBPersonCard } from '../components/elements/cards/SBPersonCard';
import { SBTechnologyCard } from '../components/elements/cards/SBTechnologyCard';
import { SBVerticallySeparatedCard } from '../components/elements/cards/SBVerticallySeparatedCard';
import { SBMegaMenuList } from '../components/elements/layout/navigation/SBMegaMenuList';
import { SBNavigation } from '../components/elements/layout/navigation/SBNavigation';
import { SBNavigationMegaMenuItem } from '../components/elements/layout/navigation/SBNavigationMegaMenuItem';
import { SBAnimationWrapper } from '../components/elements/layout/SBAnimationWrapper/SBAnimationWrapper';
import { SBColumn } from '../components/elements/layout/SBColumn/SBColumn';
import { SBContainer } from '../components/elements/layout/SBContainer/SBContainer';
import { SBContainerWithImage } from '../components/elements/layout/SBContainerWithImage/SBContainerWithImage';
import { SBDecoratorWrapper } from '../components/elements/layout/SBDecoratorWrapper/SBDecoratorWrapper';
import { SBError } from '../components/elements/layout/SBError/SBError';
import { SBGrid } from '../components/elements/layout/SBGrid/SBGrid';
import { SBRow } from '../components/elements/layout/SBRow/SBRow';
import { SBTable } from '../components/elements/layout/SBTable/SBTable';
import { SBTableRow } from '../components/elements/layout/SBTableRow/SBTableRow';
import { SBAccordion } from '../components/elements/sections/accordion/SBAccordion';
import { SBAccordionItem } from '../components/elements/sections/accordion/SBAccordionItem';
import { SBCarousel } from '../components/elements/sections/carousel/SBCarousel';
import { SBCarouselTestimonial } from '../components/elements/sections/carousel/SBCarouselTestimonial';
import { SBCarouselWithCounters } from '../components/elements/sections/carousel/SBCarouselWithCounters';
import { SBCompetitorReportRequestForm } from '../components/elements/sections/forms/SBCompetitorReportRequestForm/SBCompetitorReportRequestForm';
import { SBEWebinarForm } from '../components/elements/sections/forms/SBEWebinarForm/SBEWebinarForm';
import { SBGetAnEstimateForm } from '../components/elements/sections/forms/SBGetAnEstimateForm/SBGetAnEstimateForm';
import { SBSuccessState } from '../components/elements/sections/forms/SBSuccessState/SBSuccessState';
import { SBBanner } from '../components/elements/sections/SBBanner/SBBanner';
import { SBBeforeAfter } from '../components/elements/sections/SBBeforeAfter/SBBeforeAfter';
import { SBBenefitItem } from '../components/elements/sections/SBBenefitsSection/SBBenefitItem';
import { SBBenefitsSection } from '../components/elements/sections/SBBenefitsSection/SBBenefitsSection';
import { SBBreadcrumbs } from '../components/elements/sections/SBBreadcrumbs/SBBreadcrumbs';
import { SBCaseStudiesGrid } from '../components/elements/sections/SBCaseStudiesGrid/SBCaseStudiesGrid';
import { SBContactInfo } from '../components/elements/sections/SBContactInfo/SBContactInfo';
import { SBCoreWebVitals } from '../components/elements/sections/SBCoreWebVitals/SBCoreWebVitals';
import { SBDoWeFitTogetherSection } from '../components/elements/sections/SBDoWeFitTogetherSection/SBDoWeFitTogetherSection';
import { SBDrivenByInnovationSection } from '../components/elements/sections/SBDrivenByInnovationSection/SBDrivenByInnovationSection';
import { SBGuaranteeSection } from '../components/elements/sections/SBGuaranteeSection/SBGuaranteeSection';
import { SBHowWeSupportYouPattern } from '../components/elements/sections/SBHowWeSupportYouPattern/SBHowWeSupportYouPattern';
import { SBJobOfferCards } from '../components/elements/sections/SBJobOfferCards/SBJobOfferCards';
import { SBMarquee } from '../components/elements/sections/SBMarquee/SBMarquee';
import { SBOpeningsBannerSection } from '../components/elements/sections/SBOpeningsBannerSection/SBOpeningsBannerSection';
import { SBOurGuaranteeSection } from '../components/elements/sections/SBOurGuaranteeSection/SBOurGuaranteeSection';
import { SBOurServicesItem } from '../components/elements/sections/SBOurServicesItem/SBOurServicesItem';
import { SBOurServicesSection } from '../components/elements/sections/SBOurServicesSection/SBOurServicesSection';
import { SBQuote } from '../components/elements/sections/SBQuote/SBQuote';
import { SBRecruitmentProcess } from '../components/elements/sections/SBRecruitmentProcess/SBRecruitmentProcess';
import { SBServiceCardItem } from '../components/elements/sections/SBServicesList/SBServiceCardItem';
import { SBServicesList } from '../components/elements/sections/SBServicesList/SBServicesList';
import { SBSupportItem } from '../components/elements/sections/SBSupportItem/SBSupportItem';
import { SBSupportSection } from '../components/elements/sections/SBSupportSection/SBSupportSection';
import { SBTableSection } from '../components/elements/sections/SBTableSection/SBTableSection';
import { SBTabs } from '../components/elements/sections/SBTabs/SBTabs';
import { SBTeaser } from '../components/elements/sections/SBTeaser/SBTeaser';
import { SBTestimonial } from '../components/elements/sections/SBTestimonial/SBTestimonial';
import { SBCollectionPageJsonLd } from '../seo/src/components/SBCollectionPageJsonLd/SBCollectionPageJsonLd';
import { SBWebpageJsonLd } from '../seo/src/components/SBWebpageJsonLd/SBWebpageJsonLd';
import { isDraftMode } from '../storyblok-preview';
import { relations } from './relations';
import { getSdk, Sdk, SdkFunctionWrapper } from './sdk';

export const getStoryblokApi = storyblokInit({
  accessToken: env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN,
  use: [apiPlugin],
  apiOptions: {
    maxRetries: 0,
  },
  components: {
    avatarGroup: SBAvatarGroup,
    cta: SBCta,
    counter: SBCounter,
    image: SBImage,
    logo: SBLogo,
    quaterCircleWithText: SBQuaterCircleWithText,
    richtext: SBRichtext,
    separator: SBSeparator,
    typography: SBTypography,
    video: SBVideo,
    aboutServiceCard: SBAboutServiceCard,
    backgroundCard: SBBackgroundCard,
    cardTestimonial: SBCardTestimonial,
    caseStudyCard: SBCaseStudyCard,
    personCard: SBPersonCard,
    technologyCard: SBTechnologyCard,
    verticallySeparatedCard: SBVerticallySeparatedCard,
    animationWrapper: SBAnimationWrapper,
    column: SBColumn,
    container: SBContainer,
    containerWithImage: SBContainerWithImage,
    decoratorWrapper: SBDecoratorWrapper,
    error: SBError,
    grid: SBGrid,
    megaMenuList: SBMegaMenuList,
    navigation: SBNavigation,
    navigationMegaMenuItem: SBNavigationMegaMenuItem,
    row: SBRow,
    table: SBTable,
    tableRow: SBTableRow,
    accordion: SBAccordion,
    accordionItem: SBAccordionItem,
    banner: SBBanner,
    beforeAfter: SBBeforeAfter,
    benefitItem: SBBenefitItem,
    benefitsSection: SBBenefitsSection,
    breadcrumbs: SBBreadcrumbs,
    carousel: SBCarousel,
    carouselTestimonial: SBCarouselTestimonial,
    carouselWithCounters: SBCarouselWithCounters,
    caseStudiesGrid: SBCaseStudiesGrid,
    contactInfo: SBContactInfo,
    coreWebVitals: SBCoreWebVitals,
    doWeFitTogetherSection: SBDoWeFitTogetherSection,
    drivenByInnovationSection: SBDrivenByInnovationSection,
    eWebinarButton: SBEWebinarButton,
    eWebinarForm: SBEWebinarForm,
    competitorReportRequestForm: SBCompetitorReportRequestForm,
    getAnEstimateForm: SBGetAnEstimateForm,
    guaranteeSection: SBGuaranteeSection,
    howWeSupportYouPattern: SBHowWeSupportYouPattern,
    jobOfferCards: SBJobOfferCards,
    marquee: SBMarquee,
    openingsBannerSection: SBOpeningsBannerSection,
    ourGuaranteeSection: SBOurGuaranteeSection,
    ourServicesItem: SBOurServicesItem,
    ourServicesSection: SBOurServicesSection,
    quote: SBQuote,
    recruitmentProcess: SBRecruitmentProcess,
    serviceCardItem: SBServiceCardItem,
    servicesList: SBServicesList,
    successState: SBSuccessState,
    supportItem: SBSupportItem,
    supportSection: SBSupportSection,
    tabs: SBTabs,
    tableSection: SBTableSection,
    teaser: SBTeaser,
    testimonial: SBTestimonial,
    page: SBPage,
    footer: SBFooter,
    header: SBHeader,
    preHeader: SBPreHeader,
    careerOffer: SBCareerOffer,
    categoriesBar: SBCategoriesBar,
    blogArticleCard: SBArticleCard,
    blogArticlesByFilters: SBArticlesByFilters,
    // content-types
    article: SBArticle,
    articleAuthor: SBArticleAuthor,
    articleCategory: SBArticleCategory,
    articleShowcase: SBArticleShowcase,
    collectionPageJsonLd: SBCollectionPageJsonLd,
    webpageJsonLd: SBWebpageJsonLd,
  },
});

export const api = storyblokInit({
  accessToken: env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN,
  use: [apiPlugin],
});

interface GetStoryblokSdkInput {
  draftMode: boolean;
}

export const getStoryblokSdk = ({ draftMode }: GetStoryblokSdkInput): Sdk => {
  const isDraftModeEnabled = isDraftMode(draftMode);

  const wrapper: SdkFunctionWrapper = action => {
    const options: ISbStoriesParams = {
      version: isDraftModeEnabled ? 'draft' : 'published',
      resolve_relations: relations,
    };

    return action(options);
  };

  return getSdk(api, wrapper);
};

export * from './relations';
export * from './tags';
